export const PAYMENTS_LOADING = "PAYMENTS_LOADING";
export const GET_PAYMENT_HISTORY = "GET_PAYMENT_HISTORY";
export const STRIPE_PAYMENT_SUCCESS = "STRIPE_PAYMENT_SUCCESS";
export const STRIPE_PAYMENT_FAIL = "STRIPE_PAYMENT_FAIL";
export const CLASSI_CREDIT_PAYMENT_SUCCESS = "CLASSI_CREDIT_PAYMENT_SUCCESS";
export const CLASSI_CREDIT_PAYMENT_FAIL = "CLASSI_CREDIT_PAYMENT_FAIL";
export const REMOVE_PAYMENT_DATA = "REMOVE_PAYMENT_DATA";
